import Tasks from 'APP/Tasks';
import { ScheduleSettingsPopup } from 'APP/main/PopupManager/Popups/ScheduleSettingsPopup/ScheduleSettingsPopup';
import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';
import { TextPayload } from 'STORE/Messages/Message/Payload/TextPayload/TextPayload';
import { Quote } from 'STORE/Messages/Message/Quote/Quote';

import { TMediaMessagePayload } from '../MediaMessagePopup.types';

type TSendPayload = TMediaMessagePayload | TextPayload;

const getSendPayloads = (payloads: TMediaMessagePayload[], caption: string): TSendPayload[] => {
  const sendPayloads: TSendPayload[] = [];
  let comment = caption;

  if (caption.length > 0 && payloads.length > 1) {
    sendPayloads.push(new TextPayload({ text: comment }));

    comment = '';
  }

  payloads.forEach((payload) => {
    payload.comment = comment;
    sendPayloads.push(payload);
  });

  return sendPayloads;
};

export const sendMediaMessages = async (
  groupId: string,
  payloads: TMediaMessagePayload[],
  caption: string,
  mustBeScheduled: boolean,
  repliedMessage?: ChatMessage,
  quote?: Quote
): Promise<boolean> => {
  const sendPayloads = getSendPayloads(payloads, caption);

  let canSendError = '';
  sendPayloads.every((payload) => {
    const canSend = Tasks.messaging.canSendMessage({
      groupId,
      payload,
      isCheckSlowMode: !mustBeScheduled,
    });

    canSendError = !canSend.result ? canSend.error! : '';
    return canSend.result;
  });

  if (canSendError) {
    Tasks.app.showToast(canSendError);
    return false;
  }

  if (mustBeScheduled) {
    Tasks.app.openPopup(ScheduleSettingsPopup, {
      params: {
        onSubmit: async (date: Date): Promise<void> => {
          const scheduleTime = date.getTime();
          let result = false;

          for (let i = 0; i < sendPayloads.length; i++) {
            const createResult = await Tasks.messaging.createScheduledMessage(groupId, {
              payload: sendPayloads[i],
              repliedMessage,
              quote,
              scheduleTime: scheduleTime + i,
            });

            result = result || createResult;
          }

          if (result) {
            Tasks.group.setActiveGroup({
              groupId: Entities.GroupsStore.getGroupById(groupId)?.scheduleGroupId,
            });
          }
        },
      },
    });

    return true;
  }

  Tasks.messaging.createNewMessages(
    groupId,
    sendPayloads.map((payload) => ({ payload, repliedMessage, quote }))
  );

  return true;
};
